import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circuit-ground-digital', 'CircuitGroundDigital', [["path",{"d":"M12 13v-10"}],["path",{"d":"M12 21l-6 -8h12l-6 8"}]]);